import { render, staticRenderFns } from "./ReturnReasonDlg.vue?vue&type=template&id=744124ac&"
import script from "./ReturnReasonDlg.vue?vue&type=script&lang=js&"
export * from "./ReturnReasonDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports